"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _control = _interopRequireDefault(require("@/components/customPage/control.vue"));
var _choice = _interopRequireDefault(require("@/components/customPage/choice.vue"));
var _colour = _interopRequireDefault(require("@/components/customPage/colour.vue"));
var _slider = _interopRequireDefault(require("@/components/customPage/slider.vue"));
var _choose = _interopRequireDefault(require("@/components/customPage/choose.vue"));
var _nftblind = _interopRequireDefault(require("@/components/customChildren/nftblind.vue"));
var _blindBox = _interopRequireDefault(require("@/components/customChildren/blindBox.vue"));
var _select = _interopRequireDefault(require("@/components/hyperlinkSelect/select.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  props: {
    cData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    loadMore: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  components: {
    control: _control.default,
    colour: _colour.default,
    slider: _slider.default,
    Nftblind: _nftblind.default,
    blindBox: _blindBox.default
  },
  data: function data() {
    return {
      contentdef: {},
      styleData: [{
        value: 1,
        src: 'https://artimg2.artart.cn/image/20211015/0a4639a5c33001d5987e8ca38eef4749.png',
        name: '单列模式'
      }, {
        value: 2,
        src: 'https://artimg2.artart.cn/image/20211015/51efec5b8f2b8b4fdec00c15219df8f4.png',
        name: '日历模式'
      }],
      imgStyleData: [{
        value: 2,
        src: 'https://artimg2.artart.cn/image/20211022/c719f4bdc74747264108875c4397d185.png',
        name: '完整图片'
      }, {
        value: 3,
        src: 'https://artimg2.artart.cn/image/20211015/7369d6f13f0a6a1ef2ac4141b9bdc1e4.png',
        name: '截取图片'
      }],
      flag: false
    };
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: {
    content: {
      get: function get() {
        if (this.cData && this.cData.dataType) {
          return this.cData.content;
        } else {
          return this.$store.getters.content;
        }
      },
      set: function set(value) {
        if (this.cData && this.cData.dataType) {
          this.cData.content = value;
        } else {
          var data = {
            key: 'content',
            value: value
          };
          this.$store.commit('finish/setAttribute', data);
        }
      }
    },
    facade: {
      get: function get() {
        if (this.cData && this.cData.dataType) {
          return this.cData.facade;
        } else {
          return this.$store.getters.facade;
        }
      },
      set: function set(value) {
        if (this.cData && this.cData.dataType) {
          this.cData.facade = value;
        } else {
          var data = {
            key: 'facade',
            value: value
          };
          this.$store.commit('finish/setAttribute', data);
        }
      }
    }
  },
  /**
   * 页面渲染前
   * @return {[type]} [description]
   */
  created: function created() {},
  /**
   * 页面加载执行
   * @return {[type]} [description]
   */
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    setStyle: function setStyle(val) {
      if (this.content.style !== val) {
        this.content.style = val;
        if (val > 2 && this.content.img_style === 1) {
          this.content.img_style = 2;
        }
        if (val === 4) {
          this.facade.img_width = 240;
          this.facade.img_height = 240;
        } else if (val === 5) {
          this.facade.img_width = 600;
          this.facade.img_height = 380;
        }
      }
    },
    is_active: function is_active(item) {
      if (item.value === this.content.style) {
        return true;
      }
      return false;
    },
    is_imgactive: function is_imgactive(item) {
      if (item.value === this.content.img_style) {
        return true;
      }
      return false;
    },
    /**
     * 删除元素
     * @return {[type]} [description]
     */
    handleDelete: function handleDelete(index) {
      this.content.data.splice(index, 1);
    },
    /**
     * 添加元素
     * @return {[type]} [description]
     */
    handleAdditem: function handleAdditem() {
      this.$refs.course.changeshow();
      // this.flag = true;
      // if (this.content.data.length < 20) {
      //   this.content.data.push({
      //     url: '',
      //     title: '导航',
      //     link: {}
      //   });
      // } else {
      //   this.$message({
      //     message: '最多添加20个图文导航',
      //     type: 'warning'
      //   });
      // }
    },
    goUp: function goUp(index) {
      if (index === 0) {
        return;
      }
      this.content.data.splice(index - 1, 0, this.content.data[index]);
      this.content.data.splice(index + 1, 1);
    },
    goDown: function goDown(index) {
      if (index === this.content.data - 1) {
        return;
      }
      this.content.data.splice(index + 2, 0, this.content.data[index]);
      this.content.data.splice(index, 1);
    },
    uploadIconAction: function uploadIconAction(res, file, index) {
      if (res && res.url) {
        var newFile = file;
        newFile.url = res.url;
        this.content.data[index].url = res.url;
      }
    },
    selectMessage: function selectMessage(data) {
      this.content.data = data.data;
    },
    delImg: function delImg(key, key1) {
      if (key1) {
        this.facade[key1][key] = '';
      } else {
        this.facade[key] = '';
      }
    },
    // 上传图片
    modalPicTap: function modalPicTap(tit, key, key1) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (key1) {
          _this.facade[key1][key] = img[0];
        } else {
          _this.facade[key] = img[0];
        }
      }, tit);
    }
  }
};
exports.default = _default2;